import { PlaygroundPosition } from '../pages/PlaygroundPage/PlaygroundPage';

/**
 * Position mappings for different table sizes
 * Each array represents positions starting from seat 0
 */
const POSITION_MAPPINGS: Record<number, PlaygroundPosition[]> = {
  2: ['SB', 'BB'],
  3: ['BTN', 'SB', 'BB'],
  4: ['BTN', 'SB', 'BB', 'UTG'],
  5: ['BTN', 'SB', 'BB', 'UTG', 'CO'],
  6: ['BTN', 'SB', 'BB', 'UTG', 'MP', 'CO'],
  7: ['BTN', 'SB', 'BB', 'UTG', 'MP', 'HJ', 'CO'],
  8: ['BTN', 'SB', 'BB', 'UTG', 'UTG+1', 'MP', 'HJ', 'CO'],
  9: ['BTN', 'SB', 'BB', 'UTG', 'UTG+1', 'MP', 'LJ', 'HJ', 'CO'],
  10: ['BTN', 'SB', 'BB', 'UTG', 'UTG+1', 'UTG+2', 'MP', 'LJ', 'HJ', 'CO']
};

/**
 * Converts a seat index to position label for a given table size
 */
export const getPositionLabel = (seatIndex: number, maxPlayers: number): PlaygroundPosition => {
  const posArray = POSITION_MAPPINGS[maxPlayers] || POSITION_MAPPINGS[9];
  return posArray[seatIndex] || 'UTG';
};

/**
 * Converts a position label to seat ID for a given table size
 */
export const getSeatIdFromPosition = (position: PlaygroundPosition, maxPlayers: number): number => {
  const posArray = POSITION_MAPPINGS[maxPlayers] || POSITION_MAPPINGS[9];
  return posArray.indexOf(position);
};

/**
 * Creates initial auto-fold set (excludes SB, BB, and Hero)
 * In poker, typically only SB, BB, and Hero are active initially
 */
export const createInitialAutoFoldIds = (maxPlayers: number, heroPosition: PlaygroundPosition): Set<number> => {
  const autoFoldIds = new Set<number>();
  const heroSeatId = getSeatIdFromPosition(heroPosition, maxPlayers);
  
  for (let i = 0; i < maxPlayers; i++) {
    // Keep SB (1), BB (2), and Hero active
    if (i !== 1 && i !== 2 && i !== heroSeatId) {
      autoFoldIds.add(i);
    }
  }
  
  console.log(`[AUTO-FOLD] Created initial auto-fold set for ${maxPlayers} players with hero at ${heroPosition} (seat ${heroSeatId}):`, Array.from(autoFoldIds));
  return autoFoldIds;
};

/**
 * Calculates initial stack sizes for input mode
 * Default stack is 100x big blind, with blinds already posted
 */
export const getInitialStacks = (maxPlayers: number, bigBlind: number, smallBlind: number): Record<number, number> => {
  const defaultStackSize = bigBlind * 100; // 100x BB
  const initialStacks: Record<number, number> = {};
  
  for (let i = 0; i < maxPlayers; i++) {
    if (i === 1) { // SB
      initialStacks[i] = defaultStackSize - smallBlind;
    } else if (i === 2) { // BB
      initialStacks[i] = defaultStackSize - bigBlind;
    } else {
      initialStacks[i] = defaultStackSize;
    }
  }
  
  return initialStacks;
};